export default "__VITE_ASSET__arjdRwcT__"